module.exports = __webpack_public_path__ + "img/brand-24.3ac6154a.png";